/** @type {import("@mui/material").SxProps<Theme>} */

const styles = theme => ({
  container: {
    justifyContent: 'center',
    background: theme.palette.primary.boxShadow3Dark,
    borderTopLeftRadius: '0.625rem',
    borderTopRightRadius: '0.625rem',
  },
  monthlyCostContainer: {
    height: 'unset',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    flexGrow: 1,
    maxWidth: '100%',
    p: '2rem 2rem 0rem 2rem',
    borderTopLeftRadius: '0.625rem',
    borderTopRightRadius: '0.625rem',
    [theme.breakpoints.down('sm')]: {
      background: theme.palette.primary.boxShadow3Dark,
      p: '1rem',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      p: '0rem',
    },
    [theme.breakpoints.between('md', 'lg')]: {
      p: '1rem',
    },
  },
  boxColor: {
    height: '100%',
    pr: 2,

    [theme.breakpoints.between('sm', 'lg')]: {
      p: 2,
    },
    [theme.breakpoints.down('sm')]: {
      p: 0,
      background: 'transparent',
    },
  },

  expandMoreIcon: {
    border: `1px solid ${theme.palette.primary.buttonColor}`,
    background: theme.palette.primary.buttonColor,
    color: theme.palette.secondary.contrastText,
    borderRadius: '4100px',
    height: '2rem',
    width: '2rem',
    cursor: 'pointer',

    [theme.breakpoints.down('sm')]: {
      mb: '-18px',
      border: 'none',
      position: 'relative ',
      top: '-1rem',
      height: '27px',
      width: '27px',
    },
  },

  expandIcon: {
    border: `1px solid ${theme.palette.primary.buttonColor}`,
    background: theme.palette.primary.buttonColor,
    color: theme.palette.secondary.contrastText,
    borderRadius: '4100px',
    cursor: 'pointer',
    height: '2rem',
    width: '2rem',
    m: '0 auto',
    mt: '1rem',
    [theme.breakpoints.between('sm', 'lg')]: {
      mr: '1rem',
      mt: '1rem',
    },

    [theme.breakpoints.down('sm')]: {
      border: 'none',
      mb: 0,
      position: 'relative ',
      top: '1rem',
      background: theme.palette.secondary.errorCTA,
    },
  },
  cartTitle: {
    color: theme.palette.primary.textColor3,
    textAlign: 'center',
  },
  priceDetails: {
    pr: '2rem',
    [theme.breakpoints.down('sm')]: {
      p: 0,
    },
  },
  priceContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  priceTitle: {
    color: theme.palette.primary.textColor3,
  },
  totalPrice: {
    color: theme.palette.primary.textColor3,

    ml: 1,
    textAlign: 'center',
  },
  cartSummary: {
    width: '100%',
    p: '1.1rem 2rem',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
    [theme.breakpoints.down('sm')]: {
      pr: 0,
      pl: 0,
      pt: 0,
      pb: 0,
    },
  },
  bottomCart: {
    pr: 2,
    pl: 2,
    pt: 2,
    pb: 2,
    bgcolor: theme.palette.primary.contrastText,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      pr: 0,
    },
    [theme.breakpoints.down('md')]: {
      pl: 0,
      pt: 4,
      pb: 4,
    },
  },
  swipeDrawer: {
    left: 0,
    right: 0,
    backdropFilter: 'blur(4.5px)',
    height: 'auto',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      // background: 'transparent',
      borderRadius: '10px 0 0 10px',
    },
  },

  boxDrawerBg: {
    height: '100%',
    overflow: 'auto',
    width: '100%',
    background: theme.palette.primary.boxShadow3Dark,
    borderRadius: '10px 0 0 10px',
    [theme.breakpoints.down('sm')]: {
      background: 'transparent',
    },
  },
  itemBox: {
    p: 1,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '93%',
      p: '8px 0',
    },
  },

  expandMore: {
    p: 0,
  },
  afterPriceContainer: {
    [theme.breakpoints.down('sm')]: {
      width: '75%',
    },
  },
  contactNumber: {
    fontFamily: theme?.typography?.body1.fontFamily,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    color: theme.palette.primary.textColor5,
    display: 'flex',
  },
  contactNumberBold: {
    fontFamily: theme?.typography?.body1.fontFamily,
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    color: theme.palette.primary.offerPromo,
  },
  strikedPrice: {
    textDecoration: 'line-through',
    lineHeight: '1.5rem',
    color: theme.palette.primary.offerPromo,
    [theme.breakpoints.down('lg')]: {
      pl: 0,
    },
  },
  ctastyle1: {
    border: `0.1875rem solid ${theme.palette.primary.main}`,
    width: '121px',
    padding: '0.3125rem',

    minHeight: '2.5rem',
    color: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      width: '140px',
    },
  },
  ctastyle2: {
    border: `0.1875rem solid ${theme.palette.secondary.errorCTA}`,
    width: '121px',
    padding: '0.3125rem',
    minHeight: '2.5rem',
    background: theme.palette.secondary.errorCTA,
    color: theme.palette.primary.contrastText,
    [theme.breakpoints.down('sm')]: {
      width: '140px',
    },
    '&:hover': {
      border: `0.1875rem solid ${theme.palette.primary.hoverCTA}`,
      background: theme.palette.primary.hoverCTA,
      color: theme.palette.primary.contrastText,
    },
  },
  ctaDisable: {
    '&.Mui-disabled': {
      background: '#a6a8a9',
      color: theme.palette.primary.contrastText,
      borderRadius: '6.25rem',
      width: '121px',
      padding: '0.3125rem',
      minHeight: '2.5rem',
      fontFamily: theme.typography.button.fontFamily,
      fontStyle: 'normal',
      fontSize: '1rem',
      lineHeight: '1.5rem',
      textTransform: 'none',
    },
  },
  ctaContainer: {
    padding: '0 2rem',
    justifyContent: 'center',

    [theme.breakpoints.down('sm')]: {
      gridRowGap: '1rem',
    },
  },
  ctagrid: {
    [theme.breakpoints.up('sm')]: {
      marginTop: '1rem',
    },
  },
  offerDiscount: {
    width: '96%',
    p: '8px',
    marginBottom: '8px',
    background: theme.palette.primary.offerBackground,
    borderRadius: '4px',
  },
  deleteIcon: {
    pt: '.7rem',
    mr: '-.2rem',
  },
});

export default styles;
